module.exports = __webpack_public_path__ + "static/Gotham-Book-b4ab8b3df64427f5e86c13fe8051868d.woff";